import { render, staticRenderFns } from "./CupomTemplateCard.vue?vue&type=template&id=60b166ff&scoped=true&lang=pug"
import script from "./CupomTemplateCard.vue?vue&type=script&lang=js"
export * from "./CupomTemplateCard.vue?vue&type=script&lang=js"
import style0 from "./CupomTemplateCard.vue?vue&type=style&index=0&id=60b166ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b166ff",
  null
  
)

export default component.exports